'use client';

import { createContext, type ReactNode, useContext } from 'react';

/**
 * Built-in labels of the shared components (screen-reader names and the few
 * visible words). Apps pass their translations via `UiLabelsProvider`; the
 * English defaults only apply outside a provider (DEV-537).
 */
export type UiLabels = {
  close: string;
  loading: string;
  /** Name of the toast region (Sonner appends the hotkey). */
  notifications: string;
  toggleSidebar: string;
  previousPage: string;
  nextPage: string;
  previous: string;
  next: string;
  morePages: string;
  previousSlide: string;
  nextSlide: string;
};

export const DEFAULT_UI_LABELS: UiLabels = {
  close: 'Close',
  loading: 'Loading',
  notifications: 'Notifications',
  toggleSidebar: 'Toggle Sidebar',
  previousPage: 'Go to previous page',
  nextPage: 'Go to next page',
  previous: 'Previous',
  next: 'Next',
  morePages: 'More pages',
  previousSlide: 'Previous slide',
  nextSlide: 'Next slide',
};

const UiLabelsContext = createContext<UiLabels>(DEFAULT_UI_LABELS);

export function UiLabelsProvider({
  labels,
  children,
}: {
  labels: UiLabels;
  children: ReactNode;
}) {
  return (
    <UiLabelsContext.Provider value={labels}>
      {children}
    </UiLabelsContext.Provider>
  );
}

export function useUiLabels(): UiLabels {
  return useContext(UiLabelsContext);
}
